import {Map, fromJS, List} from "immutable";

import {FETCH_TECHNICALS_SHEETS_REQUEST, FETCH_TECHNICALS_SHEETS_SUCCESS, FETCH_TECHNICALS_SHEETS_ERROR, CLEAN_TECHNICALS_SHEETS_STATE} from "./technicals-sheets-actions"

const technicalsSheets = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case FETCH_TECHNICALS_SHEETS_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case FETCH_TECHNICALS_SHEETS_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case FETCH_TECHNICALS_SHEETS_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        // Clean State
        case CLEAN_TECHNICALS_SHEETS_STATE:
            newState = state.merge({
                payload: undefined,
                isFetching: false,
                error: false
            });
            return newState;

        default:
            return state;
    }
};

export default technicalsSheets;